export default "__VITE_ASSET__CknLPfF4__"